export default __webpack_public_path__ + "fonts/react_logo_active.9f2cb50b5bc2e1c3bbaf66a378690b51.png";